var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightTickFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_267_20917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 1.74186C21.4607 2.87397 23.0918 4.49854 24.2318 6.45475C25.3717 8.41096 25.981 10.631 25.9993 12.895C26.0175 15.159 25.4442 17.3886 24.336 19.363C23.2278 21.3373 21.6232 22.988 19.681 24.1517C17.7388 25.3153 15.5264 25.9515 13.2627 25.9973C10.9991 26.0432 8.76271 25.497 6.77502 24.4129C4.78733 23.3288 3.11723 21.7443 1.93007 19.8164C0.742901 17.8885 0.0798321 15.684 0.00650015 13.4211L0 12.9999L0.00650015 12.5787C0.0793042 10.3335 0.732612 8.14561 1.90273 6.22815C3.07285 4.31069 4.71985 2.72915 6.68316 1.63771C8.64647 0.546267 10.8591 -0.017824 13.1053 0.000429319C15.3515 0.0186827 17.5547 0.618657 19.5 1.74186ZM17.8191 9.48076C17.5952 9.25693 17.2974 9.12247 16.9815 9.1026C16.6656 9.08274 16.3532 9.17883 16.1031 9.37286L15.9809 9.48076L11.7 13.7604L10.0191 12.0808L9.8969 11.9729C9.64676 11.779 9.33448 11.683 9.01863 11.7029C8.70277 11.7228 8.40503 11.8573 8.18124 12.0811C7.95745 12.3049 7.82299 12.6026 7.80306 12.9185C7.78313 13.2343 7.87911 13.5466 8.073 13.7968L8.1809 13.919L10.7809 16.519L10.9031 16.6269C11.1311 16.8037 11.4114 16.8997 11.7 16.8997C11.9886 16.8997 12.2689 16.8037 12.4969 16.6269L12.6191 16.519L17.8191 11.319L17.927 11.1968C18.121 10.9466 18.2171 10.6343 18.1973 10.3184C18.1774 10.0024 18.0429 9.70461 17.8191 9.48076Z",
    fill: "#37AC20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_267_20917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightTickFilled);
export default __webpack_public_path__ + "static/media/right-tick-filled.d6274614519b59ab923251c8feb8d564.svg";
export { ForwardRef as ReactComponent };